import { useColorMode } from '@chakra-ui/react';
import { useEffect } from 'react';
import { glowLayerStyle, buttonBoxColorStyle } from '../constants/HomeStyleConst';
import GradientPlusIcon from '../../../components/icons/GradientPlusIcon';
import { t } from 'i18next';
import EmptyCase from '../../../components/errors/EmptyCase.js';
import { useNavigate } from 'react-router-dom';

export default function EmptyMyPhotoCardContent() {
  const { colorMode } = useColorMode();
  const navigate = useNavigate();

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  const backgroundStyles = {
    light:
      'linear-gradient(to bottom, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0.3) 5%, rgba(255, 255, 255, 0.5) 20%, rgba(255, 255, 255, 0.8) 30%, rgba(255, 255, 255, 1) 55%)',
    dark: 'linear-gradient(to bottom, rgba(13, 14, 18, 0.5) 0%, rgba(13, 14, 18, 0.8) 30%, rgba(13, 14, 18, 1) 55%)'
  };

  return (
    <div
      className="absolute inset-0 -left-[24px] -right-[24px] flex items-center justify-center z-10"
      style={{
        background: backgroundStyles[colorMode],
        backdropFilter: 'blur(0.5px)',
        WebkitBackdropFilter: 'blur(2px)'
      }}
    >
      <div className="flex flex-col items-center gap-[37px] w-dvw absolute top-[40%] left-1/2 transform -translate-x-1/2 -translate-y-1/2">
        {/* @ts-expect-error */}
        <EmptyCase
          emoji={'😳'}
          title={t('CollectionsHomePage.NoCollectedPhotoCards')}
          description={t('CollectionsHomePage.NoCollectedPhotoCardsDescription')}
        />
        <div className="relative z-10">
          <div
            className="absolute inset-0 z-[-1] rounded-[100px] animate-blur"
            style={glowLayerStyle[colorMode]}
          />
          <button
            className="h-[39px] w-[155px] border-none rounded-[100px]"
            type="button"
            onClick={() => navigate('/collections/select-method')}
            style={buttonBoxColorStyle[colorMode].bgColorStyle}
          >
            <div className="flex flex-row items-center gap-[4px] justify-center">
              <GradientPlusIcon width={15} height={16} className="fill-white" />
              <p
                className="text-[14px] font-semibold leading-normal"
                style={buttonBoxColorStyle[colorMode].textColorStyle}
              >
                {t('CollectionsHomePage.EditPhotoCardFabButton')}
              </p>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
}
